import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { action } from "mobx";
import { observer } from "mobx-react";
import { DatePicker, LocaleProvider } from "antd";
import enUS from "antd/lib/locale-provider/en_US";
import Icon from "module-common/Icon";
import Picker from "module-common/Picker";
import PickerAgent from "module-common/PickerAgentWithQuery";
import PickerChannel from "module-common/PickerChannelWithQuery";
import PickerMultiLabel from "module-common/PickerMultiLabelWithQuery";
import Field from "./Field";

const filterType = {
  content: "Content",
  date: "Date",
  channel: "Channel",
  agent: "Agent"
};
const allFilterType = [
  filterType.date,
  filterType.channel,
  filterType.agent,
  filterType.content
];
export default observer(
  class Filter extends Component {
    static propTypes = { store: PropTypes.object.isRequired };

    render() {
      const store = this.props.store;
      // decide icon to render
      let icon;
      if (store.activeFilters.length === 1) {
        icon = <Icon name="filter" height={24} width={18} />;
      } else {
        icon = (
          <Icon
            name="refresh"
            height={24}
            width={18}
            onClick={this.clearFilter}
          />
        );
      }

      return (
        <Wrapper>
          {icon}
          <Filters>{this.renderFilters()}</Filters>
        </Wrapper>
      );
    }

    renderFilters = () => {
      const store = this.props.store;
      const filters = store.activeFilters;
      const renders = [];
      const length = filters.length;
      for (let i = 0; i < filters.length; i++) {
        const filter = filters[i];
        let buttonAdd;
        let buttonMinus = (
          <Icon
            name="minus"
            width={20}
            onClick={() => {
              this.resetFilter(filter);
              this.deleteFilter(i);
            }}
          />
        );

        // if there is only one filter then no need to show minus button
        if (i === 0 && length === 1) {
          buttonMinus = null;
        }
        // if all filter options has been shown, no need to show add button
        if (i === length - 1 && i !== 4) {
          buttonAdd = <Icon name="plus" width={20} onClick={this.addFilter} />;
        }
        renders.push(
          <Row key={i}>
            <Picker
              options={this.getUnusedFilters()}
              onSelected={row => {
                this.resetFilter(filter);
                filters[i] = row.label;
              }}
            >
              <Field text={filter} width={70} />
            </Picker>
            {this.renderPicker(filter)}
            {buttonAdd}
            {buttonMinus}
          </Row>
        );
      }
      return renders;
    };

    renderPicker = type => {
      const store = this.props.store;
      let picker;
      switch (type) {
        case filterType.agent:
          {
            const agent = store.filterAgent;
            const text = agent ? agent.displayName : "All Agents";
            picker = (
              <PickerAgent
                onSelected={selected => (store.filterAgent = selected.value)}
                showAllAgents={true}
              >
                <Field text={text} flex />
              </PickerAgent>
            );
          }
          break;
        case filterType.channel:
          {
            const channel = store.filterChannel;
            const text = channel
              ? `@${channel.name} (${channel.channel.name})`
              : "All Channels";
            picker = (
              <PickerChannel
                onSelected={selected => (store.filterChannel = selected.value)}
              >
                <Field text={text} flex />
              </PickerChannel>
            );
          }
          break;
        case filterType.date:
          picker = (
            <LocaleProvider locale={enUS}>
              <DatePicker.RangePicker
                format="DD/MM/YYYY"
                onChange={this.onChangeDate}
              />
            </LocaleProvider>
          );
          break;
        case filterType.content:
          picker = (
            <Form onSubmit={this.onSubmit}>
              <Input
                type="text"
                defaultValue={store.filterContent}
                innerRef={input => (this.content = input)}
              />
            </Form>
          );
          break;
        default:
      }
      return picker;
    };

    onSubmit = e => {
      const store = this.props.store;
      store.filterContent = this.content.value;
      this.content.blur();
      e.preventDefault();
    };

    onChangeDate = e => {
      const store = this.props.store;
      store.filterStartDate = e[0];
      store.filterEndDate = e[1];
    };

    getUnusedFilters = () => {
      const store = this.props.store;
      const unused = allFilterType.filter(
        filter => !store.activeFilters.includes(filter)
      );
      const rows = [];
      for (const row of unused) {
        rows.push({ label: row });
      }
      return rows;
    };

    resetFilter = type => {
      const store = this.props.store;
      switch (type) {
        case filterType.agent:
          store.filterAgent = null;
          break;
        case filterType.channel:
          store.filterChannel = null;
          break;
        case filterType.date:
          store.filterStartDate = null;
          store.filterEndDate = null;
          break;
        case filterType.content:
          store.filterContent = null;
          break;
        default:
      }
    };

    clearFilter = action(() => {
      const store = this.props.store;
      store.activeFilters = ["Content"];
      store.filterContent = null;
      store.filterStartDate = null;
      store.filterEndDate = null;
      store.filterChannel = null;
      store.filterAgent = null;
    });

    deleteFilter = index => {
      const store = this.props.store;
      const filters = store.activeFilters;
      const deletedFilter = filters[index];
      this.resetFilter(deletedFilter);
      filters.splice(index, 1);
    };

    addFilter = () => {
      const store = this.props.store;
      const filters = store.activeFilters;
      filters.push(this.getUnusedFilters()[0].label);
    };
  }
);

const Wrapper = styled.div`
  padding: 8px;
  flex: none;
  display: flex;
  border-bottom: 1px solid ${props => props.theme.panelBorder};
`;
const Filters = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;
const Row = styled.div`
  display: flex;
  align-items: center;
`;
const Form = styled.form`
  display: flex;
  flex: 1;
`;
const Input = styled.input`
  flex: 1;
  margin: 2px;
  padding: 0px 4px;
  border: 1px solid ${props => props.theme.panelBorder};
  border-radius: 4px;
`;



// WEBPACK FOOTER //
// ./src/module-schedule/filter/FilterWithStore.js